import React from 'react';
import styles from '../MockServices/MockServices.module.css';
import MockTemplatesListBlazeTable from './MockTemplatesListBlazeTable';
import FilterBar from '../../FilterBar/FilterBar';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store/rootReducer';
import {
  getMockServiceTemplates,
  updateFilter,
} from '../../../../store/mockServiceTemplates/mockServiceTemplatesActions';

const TemplatesTabContent = () => {
  const filter = useSelector((state: ApplicationState) => state.mockServiceTemplates.filter);
  const dispatch = useDispatch();

  return (
    <div className={styles.mockServiceTemplatePanel + ' card'}>
      <div className={'card-body'}>
        <FilterBar
          config={{ serviceFilter: true, searchFilter: true, locationFilter: false, statusFilter: false }}
          filter={filter}
          onServiceChanged={() => {
            dispatch(getMockServiceTemplates());
          }}
          onChange={filterUpdate => {
            dispatch(updateFilter(filterUpdate));
          }}
        />
        <MockTemplatesListBlazeTable />
      </div>
    </div>
  );
};

export default TemplatesTabContent;
